import { CORNERS, ANIMATIONS } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

const AVERAGE_GENERATION_TIME = 30000;
const FINISHED_TRANSITION_TIME = ANIMATIONS.SPEED_NUMBER.NORMAL;
export const PROGRESS_BAR_LENGTH = 750;

const styleSheet = createStyleSheet({
  wrapper: {
    display: 'block',
    width: `${PROGRESS_BAR_LENGTH}px`,
    height: '15px',
    backgroundColor: 'white',
    ...CORNERS.BORDER_RADIUS('15px'),
  },
  foreground: {
    display: 'flex',
    width: '0px',
    height: '100%',
    background: 'linear-gradient(90deg, #348FFC 0px, #9747FF 600px)',
    ...CORNERS.BORDER_RADIUS('15px'),
  },
  isLoading: {
    transition: `width ${AVERAGE_GENERATION_TIME}ms linear`,
    width: `${PROGRESS_BAR_LENGTH / 1.5}px`,
  },
  isFinished: {
    transition: `${FINISHED_TRANSITION_TIME}ms`,
    width: `${PROGRESS_BAR_LENGTH}px`,
  },
});

export default styleSheet;
